export default "__VITE_ASSET__46YhZ2p5__"